import { MakeCall } from '../createMakeCall';

const unpublishUnitType = (makeCall: MakeCall) => (unitTypeId: number) =>
  makeCall<undefined>('PUT', `/api/v2/unit-type/${unitTypeId}/unpublish`);

export { unpublishUnitType };
